'use strict';

angular.module('DoohApps').factory('FileUploadHelper', ['$filter', 'Admin', 'AppAdmin', 'UploadFileStorage', 'FileUpload', 'DoohHelper',
    function ($filter, Admin, AppAdmin, UploadFileStorage, FileUpload, DoohHelper) {
    var UpLoadedVersionFiles = 0;
    return {
        ValidateNewAppFiles: function (dev, callback, scope, bll) {
            UpLoadedVersionFiles = 0;
            var dataSource = dev ? AppAdmin : Admin;
            dataSource.validateNewAppFiles(function (data) {
                var res = data.Data.Content;
                if (res.warnings.length == 0 && res.errors.length == 0) {
                    var files = UploadFileStorage.GetFiles();
                    angular.forEach(res.files, function (file, index) {
                        scope.UploadingFile = true;
                        var fileSize = files[index].size / 1024;

                        scope.AddNewVersionFile.Files[index].FileSize = (fileSize > 1024) ? Math.round((fileSize / 1024)).toFixed(2) + ' MB' : Math.round(fileSize).toFixed(2) + ' KB';
                        scope.AddNewVersionFile.Files[index].UploadingProgress = 0;
                        scope.AddNewVersionFile.Files[index].UploadingProgressBar = 0;
                        scope.AddNewVersionFile.Files[index].FileID = file.fileID;
                        let fileName = scope.AddNewVersionFile.Files[index].FileName;

                        saveNewVersionFile(files[index], fileName, index, file.url, scope, bll, scope.application.CompanyID);
                    });

                } else {
                    callback(res);
                }
            }, { files: scope.AddNewVersionFile.Files, vendor: scope.application.CompanyID });
        },
        AddVersionFile: function (scope, writeFiles, bll) {
            var files = UploadFileStorage.GetFiles();
            UpLoadedVersionFiles = 0;
            angular.forEach(writeFiles, function (file, index) {

                scope.UploadingFile = true;
                var fileSize = files[index].size / 1024;

                scope.AddNewVersionFile.Files[index].FileSize = (fileSize > 1024) ? Math.round((fileSize / 1024)).toFixed(2) + ' MB' : Math.round(fileSize).toFixed(2) + ' KB';
                scope.AddNewVersionFile.Files[index].UploadingProgress = 0;
                scope.AddNewVersionFile.Files[index].UploadingProgressBar = 0;
                let fileName = scope.AddNewVersionFile.Files[index].FileName;

                saveNewVersionFile(files[index], fileName, index, file.url, scope, bll, scope.application.CompanyID);
            });
        }
    }

    function onError(idx, scope) {
        if (scope.AddNewVersionFile.HasFile) {
            scope.AddNewVersionFile.Files[idx].error = true;
            scope.AddNewVersionFile.Files[idx].uploadRecieved = true;
            scope.AddNewVersionFile.Files[idx].uploadLinksRecieved = true;
        }
    }

    function onProgress(complate, idx, onCancel, scope) {
        if (!scope.AddNewVersionFile.HasFile) {
            onCancel();
            return;
        }

        var percentComplete = complate * 1;
        scope.AddNewVersionFile.Files[idx].UploadingProgressBar = percentComplete > 0 && percentComplete < 3 ? 3 : percentComplete;
        scope.AddNewVersionFile.Files[idx].UploadingProgress = (percentComplete > 100) ? 99 : parseInt(percentComplete);
        scope.AddNewVersionFile.Files[idx].uploadLinkRecieved = true;
        if (percentComplete == 100) scope.AddNewVersionFile.Files[idx].uploadRecieved = true;
    }

    function onFileUploaded(url, idx, scope, bll) {
        scope.AddNewVersionFile.Files[idx].FileURL = url;
        scope.AddNewVersionFile.Files[idx].FileExtension = DoohHelper.getExtensionFromUrl(url);
        scope.AddNewVersionFile.Files[idx].VersionID = scope.application.ApplicationVersionID;
        scope.AddNewVersionFile.Files[idx].CompanyID = scope.application.CompanyID;
        window.setTimeout(function () {
            bll.AddNewVersionFile(function (data) {
                scope.AddNewVersionFile.Files[idx].Error = data.error_description;

                if (scope.AddNewVersionFile.Files[idx].Error != undefined && scope.AddNewVersionFile.Files[idx].Error != '')
                    scope.AddNewVersionFile.Files[idx].error = true;
                else
                    scope.AddNewVersionFile.Files[idx].done = true;

                scope.AddNewVersionFile.Files[idx].uploadRecieved = true;
                UpLoadedVersionFiles++;
                scope.NewVersionFileAdded(data, idx, UpLoadedVersionFiles);
            }, scope.AddNewVersionFile.Files[idx]);
        }, 300);
    }

    function saveNewVersionFile(file, fileName, fileIndex, url, scope, bll, companyId) {
        var token = url.split('?')[1];
        url = url.split('?')[0];
        FileUpload.upload({
            file,
            fileName,
            url,
            token,
            onProgress: (percentComplete, onCancel) => onProgress(percentComplete, fileIndex, onCancel, scope),
            onSuccess: _url => onFileUploaded(_url, fileIndex, scope, bll),
            onError: () => onError(fileIndex, scope),
            companyId,
            useFileNameInUpload: true
        });
    }
}]);